import React, { useState, useEffect } from "react";
//ファイル
import ThtTop from "./shop/tht/ThtTop";
import { ThtHeader, ThtFooter } from "./shop/tht/ThtLayout";
import ThtNews from "./shop/tht/ThtNews";
import ThtContact from "./shop/tht/ThtContact";
import ThtCompany from "./shop/tht/ThtCompany";
import ThtBusiness from "./shop/tht/ThtBusiness";
import Class from "./shop/Class";
import ThtPrivacy from "./shop/tht/ThtPrivacy";
import Blog from "./shop/Blog";
import BlogPost from "./shop/BlogPost";
import ClassroomTop from "./shop/common/Top";
import CoursesFeesTaikan from "./shop/common/CoursesFeesTaikan";
import CoursesFees from "./shop/common/CoursesFees";
import ClassOverview from "./shop/common/ClassOverview";
import Faq from "./shop/common/Faq";
import StaffBlog from "./shop/common/StaffBlog";
import RegionBlog from "./shop/common/RegionBlog";
import RegionBlogPost from "./shop/common/RegionBlogPost";
import Join from "./shop/common/Join";
import ClassPrivacypolicy from "./shop/common/PrivacyPolicy";
import { NotoSansJp } from "./shop/common/TextStyle";
import {
  localBranchInfo,
  seedFirestoreBranchDocs,
  regionIds,
  RegionId,
} from "./shop/common/branches";
import { useBranchByRegion } from "./shop/common/useBranch";

//アイコン・ロゴ
import Logo from "./image/logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import LocationOnIcon from "@mui/icons-material/LocationOn";
//MUI
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Button,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Grid,
  Link,
} from "@mui/material";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";

const App = () => {
  const isSmartphone = useMediaQuery("(max-width:767px)");

  const isTablet = useMediaQuery("(max-width: 1024px)"); // スマートフォン用の幅を設定
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [logoVisible, setLogoVisible] = useState(false);

  // ページを移動したら、前のページのスクロール位置を引き継がず一番上から表示する
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // 1階層目のパス(例: horikawa)。教室一覧などから各教室へ移動したときにも演出を再生するため
  const firstSegment = location.pathname.split("/")[1];

  useEffect(() => {
    // ページ読み込み時・別の教室(サイト)へ移動したときにアニメーション開始
    setIsVisible(false);
    setLogoVisible(false);
    const timerBackground = setTimeout(() => setIsVisible(true), 2000); // 少し遅らせて発動
    const timerLogoBlock = setTimeout(() => setLogoVisible(true), 500);
    const timerLogoNone = setTimeout(() => setLogoVisible(false), 1000);
    // 横スクロールを無効にする
    document.body.style.overflowX = "hidden";

    return () => {
      clearTimeout(timerBackground);
      clearTimeout(timerLogoBlock);
      clearTimeout(timerLogoNone);
    };
  }, [firstSegment]);

  const pathname = location.pathname;

  // Defaultロゴ用のパス一覧
  const defaultPaths = [
    "/", // Top
    "/class",
    "/privacypolicy",
    "/company",
    "/sitemap",
    "/contact",
  ];

  // 現在の地域プレフィックス(horikawa|takaoka|tonami など)
  const region = (() => {
    const seg = pathname.split("/")[1];
    return regionIds.includes(seg as RegionId) ? (seg as RegionId) : null;
  })();
  const branchState = useBranchByRegion(region);
  const branch = branchState.status === "ready" ? branchState.branch : null;

  // 現在のパスがいずれかの支店配下か(支店トップ or 支店配下ページ)
  // THT合同会社サイトのページ(専用ヘッダー・フッターを表示)
  const isThtPath = ["/", "/news", "/business", "/company", "/contact", "/class", "/privacypolicy"].includes(pathname);

  // ブラウザのタブのアイコン:THTのページではTHTのロゴ、教室のページでは元のアイコンにする
  useEffect(() => {
    const icons: [string, string, string][] = [
      ['link[rel="icon"][sizes="32x32"]', "/favicon-32.png", "/tht-favicon-32.png"],
      ['link[rel="icon"][sizes="16x16"]', "/favicon-16.png", "/tht-favicon-16.png"],
      ['link[rel="icon"][sizes="512x512"]', "/favicon.png", "/tht-favicon-192.png"],
      ['link[rel="apple-touch-icon"]', "/apple-touch-icon.png", "/tht-favicon-180.png"],
    ];
    icons.forEach(([selector, classIcon, thtIcon]) => {
      const link = document.querySelector<HTMLLinkElement>(selector);
      if (link) link.href = isThtPath ? thtIcon : classIcon;
    });
  }, [isThtPath]);

  const isBranchPath =
    !!region && (pathname === `/${region}` || pathname.startsWith(`/${region}/`));

  const pagelists = branch
    ? [
        ...(branch.showCoursesFeesTaikan
          ? [
              {
                page: "平日【体操式】体幹・体づくり教室と料金",
                url: "/coursesfees_taikan",
              },
            ]
          : []),
        ...(branch.showCoursesFees
          ? [{ page: "土日【本格的】体操教室と料金", url: "/coursesfees" }]
          : []),
        { page: "教室概要", url: "/classoverview" },
        { page: "よくある質問", url: "/faq" },
        { page: "ブログ", url: "/blog" },
        { page: "入会までの流れ", url: "/join" },
      ]
    : [];

  const menuColumns = [
    {
      items: [
        { label: "入会までの流れ", path: "/join" },
        { label: "ブログ", path: "/blog" },
        { label: "プライバシーポリシー", path: "/classprivacypolicy" },
      ],
    },
  ];

  const regionLogo = region ? localBranchInfo[region].logo : Logo;

  const isClassroomtop = region ? pathname === `/${region}` : false;

  const buildRegionPath = (suffix: string) => {
    if (!suffix.startsWith("/")) suffix = `/${suffix}`;
    if (!region) {
      return suffix === "/" ? "/" : suffix;
    }
    if (suffix === "/") return `/${region}`;
    return `/${region}${suffix}`;
  };

  const resolvePath = (path: string) => {
    if (!path) return path;
    if (!region) return path;
    return buildRegionPath(path);
  };

  const freeTrialUrl = branch
    ? branch.freeTrialUrl
    : seedFirestoreBranchDocs.horikawa.freeTrialUrl;
  const membershipUrl = branch
    ? branch.membershipUrl
    : seedFirestoreBranchDocs.horikawa.membershipUrl;
  const loginUrl = branch
    ? branch.loginUrl
    : seedFirestoreBranchDocs.horikawa.loginUrl;

  let logoSrc = Logo;
  let itemSrc: string | null = null;
  if (defaultPaths.includes(pathname)) {
    logoSrc = Logo;
    itemSrc = "";
  } else if (isBranchPath && region) {
    logoSrc = localBranchInfo[region].logo;
    itemSrc = branch ? `\t${branch.zip} ${branch.address}` : "";
  }

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      setDrawerOpen(open);
    };

  const DrawerContent = () => {
    return (
      <Box
        sx={{ width: 150 }}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        <List>
          {branch?.showCoursesFeesTaikan && (
            <ListItem component="a" href={resolvePath("/coursesfees_taikan")}>
              <ListItemText primary="平日【体操式】体幹・体づくり教室と料金" />
            </ListItem>
          )}
          {branch?.showCoursesFees && (
            <ListItem component="a" href={resolvePath("/coursesfees")}>
              <ListItemText primary="土日【本格的】体操教室と料金" />
            </ListItem>
          )}
          <ListItem component="a" href={resolvePath("/classoverview")}>
            <ListItemText primary="教室概要" />
          </ListItem>
          <ListItem component="a" href={resolvePath("/faq")}>
            <ListItemText primary="よくある質問" />
          </ListItem>
          <ListItem component="a" href={resolvePath("/blog")}>
            <ListItemText primary="ブログ" />
          </ListItem>
          <ListItem component="a" href={resolvePath("/join")}>
            <ListItemText primary="入会までの流れ" />
          </ListItem>
          <ListItem component="a" href={freeTrialUrl}>
            <ListItemText primary="無料体験" />
          </ListItem>
          <ListItem component="a" href={membershipUrl}>
            <ListItemText primary="会員登録" />
          </ListItem>
          <ListItem component="a" href={loginUrl}>
            <ListItemText primary="会員ログイン" />
          </ListItem>
        </List>
      </Box>
    );
  };

  const drawerList = () => {
    if (isBranchPath) {
      return <DrawerContent />;
    }
    return (
      <Box
        sx={{ width: 150 }}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        <List>
          <ListItem component="a" href="/">
            <ListItemText primary="TOP" />
          </ListItem>
          <ListItem component="a" href="/class">
            <ListItemText primary="教室一覧・無料体験" />
          </ListItem>
          <ListItem component="a" href="/blog">
            <ListItemText primary="ブログ" />
          </ListItem>
          <ListItem component="a" href="/recruit">
            <ListItemText primary="採用情報" />
          </ListItem>
        </List>
      </Box>
    );
  };

  const HorikawaAppbar = () => {
    return (
      <AppBar
        position="fixed"
        sx={{
          height: "80px",
          bgcolor: "white",
          boxShadow: "none",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center", // 上下中央に配置
            height: "100%",
            padding: "0 20px",
          }}
        >
          {/* 左側のロゴ */}
          <a href={buildRegionPath("/")} style={{ display: "flex" }}>
            <img
              src={regionLogo}
              alt="branch_logo"
              style={{
                width: isSmartphone ? "50vw " : "15vw",
                objectFit: "contain", // ロゴが歪まないように設定
              }}
            />
          </a>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {isSmartphone ? (
              <>
                <IconButton
                  size="large"
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={toggleDrawer(true)}
                >
                  <MenuIcon sx={{ bgcolor: "#E0B24B", p: "5px" }} />
                </IconButton>
                <Drawer
                  anchor="top"
                  open={drawerOpen}
                  onClose={toggleDrawer(false)}
                >
                  {drawerList()}
                </Drawer>
              </>
            ) : (
              <>
                {/* メニューリスト */}
                <List
                  sx={{
                    display: isTablet ? "none" : "flex", // モバイルでは非表示
                    marginRight: "20px", // メニューとボタンの間隔
                    padding: 0, // リストの余白をリセット
                  }}
                >
                  {pagelists.map((item, index) => (
                    <Link
                      key={index}
                      sx={{
                        color: "#333333",
                        fontSize: "13px",
                        lineHeight: "1.8em",
                        letterSpacing: "2px",
                        textDecoration: "none",
                        p: "12px 20px",
                        position: "relative", // 下線を出すために相対位置に設定
                        "&:hover": {
                          color: "#E0B24B",
                        },
                        "&:before": {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          bottom: 0,
                          width: "100%",
                          height: "0", // 初期状態では下線の高さを0に設定
                          bgcolor: "#E0B24B", // 下線の色
                          transition: "height 0.3s ease", // 下線が出てくるアニメーション
                        },
                        "&:hover:before": {
                          height: "1px", // ホバー時に下線を1pxに設定
                        },
                      }}
                      href={resolvePath(item.url)}
                    >
                      {item.page}
                    </Link>
                  ))}
                </List>

                <Button
                  component="a"
                  href={freeTrialUrl}
                  sx={{
                    display: isTablet ? "none" : "block",
                    color: "#FFFFFF",
                    bgcolor: "darkgreen",
                    borderRadius: "50px",
                    p: "5px 20px",
                    fontSize: "13px",
                    transition:
                      "background-color 0.3s ease, transform 0.3s ease",
                    m: "0px 0 0 0px",
                    ...NotoSansJp,
                    "&:hover": {
                      bgcolor: "#E0B24B",
                      transform: "scale(1.1)",
                      overflow: "hidden",
                      maxWidth: "100%",
                    },
                  }}
                >
                  無料体験
                </Button>
                <Button
                  component="a"
                  href={membershipUrl}
                  sx={{
                    display: isTablet ? "none" : "block",
                    color: "#FFFFFF",
                    bgcolor: "darkblue",
                    borderRadius: "50px",
                    p: "5px 20px",
                    fontSize: "13px",
                    transition:
                      "background-color 0.3s ease, transform 0.3s ease",
                    m: "0px 0 0 30px",
                    ...NotoSansJp,
                    "&:hover": {
                      bgcolor: "#E0B24B",
                      transform: "scale(1.1)",
                      overflow: "hidden",
                      maxWidth: "100%",
                    },
                  }}
                >
                  会員登録
                </Button>
                {/* ログインボタン */}
                <Button
                  component="a" // ← アンカー要素として扱う
                  href={loginUrl}
                  sx={{
                    display: isTablet ? "none" : "block",
                    color: "#FFFFFF",
                    bgcolor: "darkorange",
                    borderRadius: "50px",
                    p: "5px 20px",
                    fontSize: "13px",
                    transition:
                      "background-color 0.3s ease, transform 0.3s ease",
                    m: "0px 0 0 30px",
                    ...NotoSansJp,
                    "&:hover": {
                      bgcolor: "#E0B24B",
                      transform: "scale(1.1)",
                      overflow: "hidden",
                      maxWidth: "100%",
                    },
                  }}
                >
                  会員ログイン
                </Button>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
    );
  };

  const getAppbarDisplay = () => {
    if (isThtPath) return <ThtHeader />;
    if (isBranchPath) {
      if (pathname === `/${region}`) {
        return (
          <>
            <Box sx={{ position: "relative" }}>
              <a href={buildRegionPath("/")}>
                <img
                  src={regionLogo}
                  alt="region_logo"
                  style={{
                    position: "absolute",
                    zIndex: 5,
                    width: isSmartphone ? "50vw" : "20vw",
                    padding: isSmartphone ? "15px" : "30px",
                  }}
                />
              </a>
              <IconButton
                size="large"
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ position: "absolute", right: 16, zIndex: 5 }}
              >
                <MenuIcon
                  sx={{
                    display: isTablet ? "block" : "none",
                    bgcolor: "#E0B24B",
                    p: "5px",
                    color: "white",
                  }}
                />
              </IconButton>
            </Box>
            <Drawer
              anchor="top"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
            >
              {drawerList()}
            </Drawer>
          </>
        );
      }
      return <HorikawaAppbar />;
    }

    return (
      <AppBar
        position="fixed"
        sx={{
          bgcolor: "white",
          color: "black",
          boxShadow: "none",
          opacity: 0.9,
        }}
      >
        <Toolbar>
          <img
            src={Logo}
            alt="Logo"
            style={{ height: isTablet ? "60px" : "100px" }}
          />
          <Box sx={{ ml: "auto", alignItems: "center" }}>
            {isTablet ? (
              <>
                <IconButton
                  size="large"
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={toggleDrawer(true)}
                >
                  <MenuIcon />
                </IconButton>
                <Drawer
                  anchor="right"
                  open={drawerOpen}
                  onClose={toggleDrawer(false)}
                >
                  {drawerList()}
                </Drawer>
              </>
            ) : (
              <>
                <Button component="a" href="/" color="inherit">
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    TOP
                  </Typography>
                </Button>
                <Button component="a" href="/recruit" color="inherit">
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    採用情報
                  </Typography>
                </Button>
                <Button component="a" href="/class" color="inherit">
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    教室一覧・無料体験
                  </Typography>
                </Button>
                <Button component="a" href="/blog" color="inherit">
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    ブログ
                  </Typography>
                </Button>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
    );
  };

  const Footer = () => {
    return (
      <Box
        sx={{
          width: "100%",
          boxSizing: "border-box", // ← 念のため
          bgcolor: "#51595C",
          // 上下 padding と左右 padding を分けて指定
          py: isSmartphone ? "50px" : "120px",
          px: isSmartphone ? "7%" : "50px",
        }}
      >
        <Grid container justifyContent="center" alignItems="flex-start">
          <Box
            sx={{
              width: isSmartphone ? "100%" : "70%",
              display: "flex",
              justifyContent: isSmartphone ? "center" : "flex-start", // ← 子要素を左寄せ
              gap: isSmartphone ? "20px" : "40px", // ← 固定の列間スペース
              flexWrap: "wrap",
            }}
          >
            {/* ── 左カラム（ロゴ＋住所＋電話） ── */}
            <Box
              component="a"
              href={buildRegionPath("/")}
              sx={{
                width: isSmartphone ? "85%" : "60%",
                display: "block",
                textDecoration: "none",
              }}
            >
              <img
                src={regionLogo}
                alt="branch_logo"
                style={{ width: isSmartphone ? "100%" : "40%" }}
              />
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: isSmartphone ? "12px" : "14px",
                  pt: "20px",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 500,
                  ...NotoSansJp,
                }}
              >
                <LocationOnIcon sx={{ fontSize: "20px", pr: "10px" }} />
                {itemSrc}
              </Typography>
            </Box>

            {/* ── メニュー列（mapで描画） ── */}
            {menuColumns.map((col, ci) => (
              <Box
                key={ci}
                sx={{
                  width: isSmartphone ? "40%" : "15%",
                  pt: isSmartphone ? "20px" : 0,
                }}
              >
                {col.items.map((item) => (
                  <Typography
                    key={item.path}
                    component="a"
                    href={resolvePath(item.path)}
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "12px",
                      p: "8px 0",
                      cursor: "pointer",
                      fontFamily: "'Noto Sans JP',sans-serif",
                      fontWeight: 500,
                      lineHeight: "1.8em",
                      letterSpacing: "2px",
                      display: "block",
                      textDecoration: "none",
                    }}
                  >
                    {item.label}
                  </Typography>
                ))}
              </Box>
            ))}
          </Box>
        </Grid>
      </Box>
    );
  };

  const ContentsBelow = () => {
    // 支店配下の場合は支店用 Footer を表示
    if (isBranchPath) return <Footer />;
    if (isThtPath) return <ThtFooter />;

    return (
      <Box
        sx={{
          bgcolor: "#1d1d1d",
          width: "100%",
          color: "white",
          padding: "80px 0",
          display: isClassroomtop ? "none" : "block",
        }}
      >
        <Grid
          container
          direction={isTablet ? "column" : "row"}
          justifyContent="center"
          alignItems="center"
          spacing={3}
        >
          <Box
            sx={{
              bgcolor: "white",
              p: "5px 10px",
              m: isTablet ? "0 0 5vh 0" : "0 5vh 0 0",
            }}
          >
            <img
              src={Logo}
              alt="logo"
              style={{ width: isTablet ? "70px" : "120px" }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: isTablet ? 2 : 5,
            }}
          >
            <Grid
              container
              direction={isTablet ? "column" : "row"}
              justifyContent="center"
              alignItems="center"
              gap={isTablet ? 2 : 4}
            >
              <Typography variant="body1" component="a" href="/" sx={{ textDecoration: "none", color: "inherit" }}>
                TOP
              </Typography>
              <Typography variant="body1" component="a" href="/class" sx={{ textDecoration: "none", color: "inherit" }}>
                教室一覧・無料体験
              </Typography>
              <Typography variant="body1" component="a" href="/blog" sx={{ textDecoration: "none", color: "inherit" }}>
                ブログ
              </Typography>
            </Grid>
            <Grid
              container
              direction={isTablet ? "column" : "row"}
              justifyContent="center"
              alignItems="center"
              gap={isTablet ? 2 : 4}
            >
              <Typography variant="body1" component="a" href="/company" sx={{ textDecoration: "none", color: "inherit" }}>
                会社概要
              </Typography>
              <Typography
                variant="body1"
                component="a"
                href="/privacypolicy"
                sx={{ textDecoration: "none", color: "inherit" }}
              >
                プライバシーポリシー
              </Typography>
              <Typography variant="body1" component="a" href="/sitemap" sx={{ textDecoration: "none", color: "inherit" }}>
                サイトマップ
              </Typography>
              <Typography variant="body1" component="a" href="/recruit" sx={{ textDecoration: "none", color: "inherit" }}>
                採用情報
              </Typography>
            </Grid>
          </Box>
        </Grid>
      </Box>
    );
  };

  return (
    <>
      {/* 読み込み時のカーテン・ロゴ演出(THTサイトでは表示しない) */}
      {!isThtPath && (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          zIndex: 9999,
          overflow: "hidden",
          pointerEvents: "none", // UI操作をブロックしない
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "#fffcba",
            width: "50%",
            transform: isVisible ? "translateX(-100%)" : "translateX(0)",
            transition: "transform 0.8s ease",
            opacity: 0.9,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            backgroundColor: "#fffcba",
            width: "50%",
            transform: isVisible ? "translateX(100%)" : "translateX(0)",
            transition: "transform 0.8s ease",
            opacity: 0.9,
          }}
        />
        {/* ロゴアニメーション */}
        <img
          src={logoSrc}
          alt="logo"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "350px",
            opacity: logoVisible ? 1 : 0,
            transformOrigin: "center",
            scale: logoVisible ? 1 : 0.8,
            transition: "opacity 0.8s ease, scale 0.8s ease",
          }}
        />
      </Box>
      )}
      <Box sx={{ flexGrow: 1 }}>
        {getAppbarDisplay()}
        <Box sx={{ paddingTop: pathname === "/" ? 0 : isThtPath ? (isTablet ? "60px" : "80px") : isTablet ? "60px" : "100px" }}>
          <Routes>
            <Route path="/" element={<ThtTop />} />
            <Route path="/class" element={<Class />} />
            <Route path="/privacypolicy" element={<ThtPrivacy />} />
            <Route path="/company" element={<ThtCompany />} />
            <Route path="/news" element={<ThtNews />} />
            <Route path="/business" element={<ThtBusiness />} />
            {/* 旧サイトマップ・旧採用情報は削除。古いURLで来た人は新しいページへ移動させる */}
            <Route path="/sitemap" element={<Navigate to="/" replace />} />
            <Route path="/contact" element={<ThtContact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:postId" element={<BlogPost />} />

            <Route path="/:region" element={<ClassroomTop />} />
            <Route
              path="/:region/coursesfees_taikan"
              element={<CoursesFeesTaikan />}
            />
            <Route path="/:region/coursesfees" element={<CoursesFees />} />
            <Route
              path="/:region/classoverview"
              element={<ClassOverview />}
            />
            <Route path="/:region/faq" element={<Faq />} />
            <Route path="/:region/staffblog" element={<StaffBlog />} />
            <Route path="/:region/blog" element={<RegionBlog />} />
            <Route path="/:region/blog/:postId" element={<RegionBlogPost />} />
            <Route path="/:region/join" element={<Join />} />

            <Route path="/recruit" element={<Navigate to="/company#recruit" replace />} />
            <Route
              path="/classprivacypolicy"
              element={<ClassPrivacypolicy />}
            />
            {/* 教室ページのフッターからは教室名付きのURL(例: /horikawa/classprivacypolicy)で来るため、こちらでも表示する */}
            <Route path="/:region/classprivacypolicy" element={<ClassPrivacypolicy />} />
          </Routes>
        </Box>
        {ContentsBelow()}
      </Box>
    </>
  );
};

export default App;
